export const DATE_TIME_ZONE = "YYYY-MM-DDTHH:mmZ";

export const FRIENDLY_DATETIME_FULL = "ddd DD/MM/YY h:mm a";

export const FRIENDLY_DATETIME_DAY_MONTH = "dddd Do MMM h:mm a";
